<ion-card-content (click)="close()" color="secondary">
  <div>
    <span *ngIf="header" class="header"><strong>{{ header }}</strong></span>
    <pre class="text">{{ text }}</pre>
  </div>
  <bhvmat-icon name="close" size="xsmall"></bhvmat-icon>
</ion-card-content>
